import React    from 'react';

class Wrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let {
            children
        } = this.props;
        return (
            <span className = { `marketkit-button-wrapper` } tabIndex="-1">
                {
                    children
                }
            </span>
        );
    }
}

export default Wrapper;